<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "DepositApplicationForApproval"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/DepositApplicationForApproval.vue